var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var uuid_1 = require("../util/uuid");
var store_1 = require("./store");
/**
 * Get a pane by its id and throw if it doesn't exist.
 */
exports.mustGetPane = function (panes, paneId) {
    if (panes.length === 0) {
        throw new Error("there's no available pane");
    }
    var foundPane = store_1.panesNsPaneSelector(panes, paneId);
    if (foundPane === undefined) {
        throw new Error("no pane found for id: " + paneId + ", available panes: " + panes.map(function (_a) {
            var id = _a.id;
            return id;
        }).join(', '));
    }
    return foundPane;
};
/**
 * Get a content by its id and throw if it doesn't exist.
 */
exports.mustGetContent = function (pane, contentId) {
    if (pane.contents.length === 0) {
        throw new Error("pane " + pane.id + " doesn't have any content");
    }
    var foundContent = pane.contents.find(function (content) { return content.id === contentId; });
    if (foundContent === undefined) {
        throw new Error("no content found in pane: " + pane.id + " for id: " + contentId + ", available contents: " + pane.contents.map(function (_a) {
            var id = _a.id;
            return id;
        }).join(', '));
    }
    return foundContent;
};
/**
 * Mark pane having provided `paneId` current pane,
 * if it's already the current one, return untouched panes.
 */
exports.setCurrentPane = function (panes, paneId) {
    exports.mustGetPane(panes, paneId);
    var currentPane = store_1.panesNsCurrentPaneSelector(panes);
    if (currentPane !== undefined && currentPane.id === paneId) {
        return panes;
    }
    return panes.map(function (pane) {
        var isCurrent = pane.id === paneId;
        if (pane.isCurrent === isCurrent) {
            return pane;
        }
        return __assign({}, pane, { isCurrent: isCurrent });
    });
};
/**
 * Append a content to current pane.
 * If the content already exists, doesn't re-append.
 * If the content is unique and already exists in the existing
 * panes, doesn't re-append, and set pane/content current,
 * meaning the content will remains unique across all panes
 * in the namespace.
 */
exports.addContentToCurrentPane = function (panes, newContent) {
    if (newContent.isUnique) {
        var existing = store_1.panesNsContentSelector(panes, newContent.id);
        if (existing !== undefined) {
            return exports.setPaneCurrentContent(panes, existing.pane.id, existing.content.id);
        }
    }
    var currentPane = store_1.panesNsCurrentPaneSelector(panes);
    if (currentPane === undefined) {
        throw new Error('unable to find a current pane');
    }
    var existingContent = currentPane.contents.find(function (content) { return content.id === newContent.id; });
    // content already exists, make sure it's current
    if (existingContent !== undefined) {
        if (existingContent.isCurrent)
            return panes;
        else {
            return panes.map(function (pane) {
                if (!pane.isCurrent)
                    return pane;
                return __assign({}, pane, { contents: pane.contents.map(function (content) {
                        var isCurrent = content.id === newContent.id;
                        if (isCurrent === content.isCurrent)
                            return content;
                        return __assign({}, content, { isCurrent: isCurrent });
                    }) });
            });
        }
    }
    return panes.map(function (pane) {
        if (!pane.isCurrent)
            return pane;
        return __assign({}, pane, { contents: pane.contents.map(function (content) {
                if (!content.isCurrent)
                    return content;
                return __assign({}, content, { isCurrent: false });
            }).concat([
                __assign({}, newContent, { isCurrent: true })
            ]) });
    });
};
/**
 * Mark pane having provided `paneId` current pane,
 * and also mark content matching provided `contentId` current content.
 * Does not touch panes/contents already in desired state.
 */
exports.setPaneCurrentContent = function (panes, paneId, contentId) {
    var currentPane = store_1.panesNsCurrentPaneSelector(panes);
    if (currentPane !== undefined && currentPane.id === paneId) {
        var currentContent = currentPane.contents.find(function (content) { return content.isCurrent; });
        if (currentContent !== undefined
            && currentContent.id === contentId) {
            // panes are already in the desired state
            return panes;
        }
    }
    var targetPane = exports.mustGetPane(panes, paneId);
    exports.mustGetContent(targetPane, contentId);
    return panes.map(function (pane) {
        if (pane.id === paneId) {
            return __assign({}, pane, { isCurrent: true, contents: pane.contents.map(function (content) {
                    var isCurrent = content.id === contentId;
                    if (content.isCurrent === isCurrent) {
                        return content;
                    }
                    return __assign({}, content, { isCurrent: isCurrent });
                }) });
        }
        if (!pane.isCurrent)
            return pane;
        return __assign({}, pane, { isCurrent: false });
    });
};
/**
 * Remove content from pane, if there's no remaining content
 * and pane does have a parent (childOf is defined),
 * un-split it.
 */
exports.removePaneContent = function (panes, paneId, contentId) {
    var targetPane = exports.mustGetPane(panes, paneId);
    exports.mustGetContent(targetPane, contentId);
    var paneUpdate;
    return panes
        .reduce(function (acc, pane) {
        if (pane.id !== paneId) {
            if (!pane.isCurrent)
                return acc.concat([pane]);
            else
                return acc.concat([__assign({}, pane, { isCurrent: false })]);
        }
        var filteredContents = pane.contents.filter(function (content) { return content.id !== contentId; });
        var contentCount = filteredContents.length;
        if (pane.childOf === undefined || contentCount > 0) {
            var contents = filteredContents;
            var hasCurrent = filteredContents.some(function (content) { return content.isCurrent; });
            if (!hasCurrent) {
                contents = filteredContents.map(function (content, i) {
                    if (i === contentCount - 1)
                        return __assign({}, content, { isCurrent: true });
                    return content;
                });
            }
            return acc.concat([
                __assign({}, pane, { isCurrent: true, contents: contents })
            ]);
        }
        // there's no remaining content && pane isn't root pane
        // we un-split parent
        var parentPane = exports.mustGetPane(panes, pane.childOf);
        var siblingPaneId = parentPane.children.find(function (childPaneId) { return childPaneId !== pane.id; });
        var siblingPane = exports.mustGetPane(panes, siblingPaneId);
        paneUpdate = {
            oldId: siblingPane.id,
            pane: __assign({}, siblingPane, { id: parentPane.id, childOf: parentPane.childOf, isCurrent: true }),
        };
        return acc;
    }, [])
        .filter(function (pane) {
        return paneUpdate === undefined || pane.id !== paneUpdate.oldId;
    })
        .map(function (pane) {
        if (paneUpdate === undefined)
            return pane;
        if (pane.id === paneUpdate.pane.id)
            return paneUpdate.pane;
        return __assign({}, pane, { childOf: pane.childOf === paneUpdate.oldId ?
                paneUpdate.pane.id : pane.childOf, children: pane.children.map(function (childId) {
                return childId === paneUpdate.oldId ? paneUpdate.pane.id : childId;
            }) });
    });
};
/**
 * Remove a content from all panes in the namespace.
 */
exports.removeContentFromAllPanes = function (panes, contentId) {
    var updatedPanes = panes;
    panes.forEach(function (pane) {
        if (pane.contents.some(function (content) { return content.id === contentId; })) {
            updatedPanes = exports.removePaneContent(panes, pane.id, contentId);
        }
    });
    return updatedPanes;
};
/**
 * Split the pane whose id is `paneId` into two child panes,
 * also set it as current pane.
 * The new pane (second child) will be created with
 * pane current content.
 */
exports.splitPane = function (panes, paneId, axis) {
    var targetPane = exports.mustGetPane(panes, paneId);
    var currentContent = targetPane.contents.find(function (content) { return content.isCurrent; });
    if (currentContent === undefined)
        return panes;
    return panes.reduce(function (acc, pane) {
        if (pane.id !== paneId) {
            if (!pane.isCurrent)
                return acc.concat([pane]);
            else
                return acc.concat([__assign({}, pane, { isCurrent: false })]);
        }
        var firstChildPaneId = uuid_1.default();
        var secondChildPaneBId = uuid_1.default();
        return acc.concat([
            {
                id: firstChildPaneId,
                contents: pane.contents,
                split: false,
                childOf: paneId,
                children: [],
                isCurrent: false,
            },
            {
                id: secondChildPaneBId,
                contents: [currentContent],
                split: false,
                childOf: paneId,
                children: [],
                isCurrent: true,
            },
            __assign({}, pane, { isCurrent: false, split: true, splitAxis: axis, contents: [], children: [
                    firstChildPaneId,
                    secondChildPaneBId,
                ] }),
        ]);
    }, []);
};
